// url
const _SERVICE = 'pims';
const _CONTACT = 'contacts';
const _CALENDAR = 'calendar';
const _REST = 'rest';
const _VERSION = 'v1';

const _API_PREFIX_CONTACT = `/${_SERVICE}/${_CONTACT}/${_REST}/${_VERSION}`;
const _API_PREFIX_CALENDAR = `/${_SERVICE}/${_CALENDAR}/${_REST}/${_VERSION}`;

const properties = {
  _API_PREFIX_CONTACT,
  _API_PREFIX_CALENDAR,
};

export default properties;
